import { HirerNotificationPreferenceForm } from '@seek/hirer-notification-preference';
import { useTranslations } from '@vocab/react';
import { Stack, Heading, Box, Strong } from 'braid-design-system';
import React from 'react';

import translations from './.vocab';

export const StepNotificationPreferencePanel = () => {
  const { t } = useTranslations(translations);
  return (
    <Box paddingTop="xsmall">
      <Stack space="large">
        <Heading level="3">
          <Strong>{t('notification-setting-preference-panel-message')}</Strong>
        </Heading>
        <Box paddingX="xxsmall" paddingY="small">
          <HirerNotificationPreferenceForm id="job-creator-notification-preference-form" />
        </Box>
      </Stack>
    </Box>
  );
};
